import React from 'react';

interface ForwardIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const ForwardIcon: React.FC<ForwardIconProps> = ({
  width = 20,
  height = 20,
  className = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9107 3.5805C12.2362 3.25507 12.7638 3.25507 13.0893 3.5805L16.4226 6.91384C16.748 7.23927 16.748 7.76691 16.4226 8.09235L13.0893 11.4257C12.7638 11.7511 12.2362 11.7511 11.9107 11.4257C11.5853 11.1002 11.5853 10.5726 11.9107 10.2472L13.8215 8.33643H6.66667C6.00363 8.33643 5.36774 8.59982 4.8989 9.06866C4.43006 9.5375 4.16667 10.1734 4.16667 10.8364C4.16667 11.4995 4.43006 12.1354 4.8989 12.6042C5.36774 13.073 6.00363 13.3364 6.66667 13.3364H7.5C7.96024 13.3364 8.33333 13.7095 8.33333 14.1698C8.33333 14.63 7.96024 15.0031 7.5 15.0031H6.66667C5.5616 15.0031 4.50179 14.5641 3.72039 13.7827C2.93899 13.0013 2.5 11.9415 2.5 10.8364C2.5 9.73136 2.93899 8.67155 3.72039 7.89015C4.50179 7.10875 5.5616 6.66976 6.66667 6.66976H13.8215L11.9107 4.75901C11.5853 4.43358 11.5853 3.90594 11.9107 3.5805Z"
      fill="currentColor"
    />
  </svg>
);

